<script setup lang="ts">
import IconVolume from '../../../../SVG/IconVolume.vue';
import { useQuizStore } from '../../../../../stores';

const quizStore = useQuizStore()

function toggleMute() {
    quizStore.bgmVolumeState.muted = !quizStore.bgmVolumeState.muted
}

</script>
<template>
    <div class="volume-control relative flex items-center justify-center p-1 border rounded-lg cursor-pointer focus:bg-gray-300"
        @click="toggleMute()">
        <IconVolume :state="quizStore.bgmVolumeState" :key="quizStore.bgmVolumeState.volume" />
    </div>

</template>